import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerHeader,
  DrawerOverlay,
  Button,
  Input,
  useToast,
  VStack,
  HStack,
  Checkbox,
  Text,
} from '@chakra-ui/react';
import AdminDrawerContent from '../layout/AdminDrawerContent';
import { AdminField, useAdminFormFieldProps } from '../layout/AdminFormControls';

const EventsEditModal = ({
  isOpen,
  onClose,
  event,
  isNew,
  onCreate,
  onUpdate,
}) => {
  const [formData, setFormData] = React.useState({});
  const toast = useToast();
  const { fieldProps } = useAdminFormFieldProps();

  React.useEffect(() => {
    if (event) {
      setFormData({
        id: event?.id,
        code: event?.code,
        name: event?.name,
        time: event?.time,
        hasComment: event?.hasComment,
        createdAt: event?.createdAt,
        updatedAt: event?.updatedAt,
      });
    } else {
      setFormData({ code: '', name: '', time: '', hasComment: false });
    }
  }, [event, isNew]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSave = () => {
    const todayDate = new Date();
    const formattedDate = `${todayDate.getFullYear()}-${String(todayDate.getMonth() + 1).padStart(2, '0')}-${String(todayDate.getDate()).padStart(2, '0')}`;

    const updatedData = {
      ...formData,
      updatedAt: formattedDate,
    };

    if (isNew) {
      updatedData.createdAt = formattedDate;
      onCreate(updatedData);
      toast({ title: 'Evento creado.', status: 'success', duration: 3000, isClosable: true });
    } else {
      onUpdate(updatedData);
      toast({ title: 'Evento actualizado.', status: 'success', duration: 3000, isClosable: true });
    }
    onClose();
  };

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} closeOnOverlayClick={false}>
      <DrawerOverlay />
      <AdminDrawerContent>
        <DrawerCloseButton />
        <DrawerHeader fontSize="lg" fontWeight="bold">
          {isNew ? 'Nuevo evento' : 'Editar evento'}
        </DrawerHeader>
        <DrawerBody>
          <VStack spacing={3} align="stretch">
            <AdminField label="Código" isRequired>
              <Input name="code" value={formData.code || ''} onChange={handleChange} {...fieldProps} />
            </AdminField>
            <AdminField label="Descripción" isRequired>
              <Input name="name" value={formData.name || ''} onChange={handleChange} {...fieldProps} />
            </AdminField>
            <AdminField label="Tiempo (minutos)">
              <Input name="time" value={formData.time || ''} onChange={handleChange} {...fieldProps} />
            </AdminField>
            <AdminField label="Lleva comentario">
              <Checkbox
                name="hasComment"
                isChecked={!!formData.hasComment}
                onChange={handleChange}
                colorScheme="gray"
              >
                <Text fontSize="sm">El evento debe contener un comentario</Text>
              </Checkbox>
            </AdminField>
          </VStack>
        </DrawerBody>
        <HStack justify="flex-end" p={4} borderTopWidth="1px" borderColor="gray.100">
          <Button size="sm" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button size="sm" variant="adminPrimary" onClick={handleSave}>
            Guardar
          </Button>
        </HStack>
      </AdminDrawerContent>
    </Drawer>
  );
};

export default EventsEditModal;
